import { render, staticRenderFns } from "./ProductsSync.vue?vue&type=template&id=fa62df2c"
import script from "./ProductsSync.vue?vue&type=script&lang=js"
export * from "./ProductsSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports